<template>
  <div class="row">
    <weather-targeting-details
      :weather-targeting-criteria="props.deal.packageTargetingCriteria"
      :targeting-criteria="targetingCriteria" />
  </div>
</template>

<script setup lang="ts">
  import { WeatherTargetingDetails } from '@/common/components/controls';
  import { Package, TargetingCriterion } from '@/common/models';

  interface IDealDetailsWeatherTargetingProps {
    deal: Package;
    targetingCriteria: TargetingCriterion[];
  }

  const props = defineProps<IDealDetailsWeatherTargetingProps>();
</script>

<style lang="scss" scoped>
  @use '@/styles/variables.scss' as *;
</style>
